import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  ADD_ORDER,
  FETCH_ORDER_DETAIL,
  FETCH_ORDER_DETAIL_RZ,
  FETCH_ORDERS,
  UPDATE_ORDER_STATUS,
} from 'store/actionTypes';
import {
  getOrderDetail,
  postOrder,
  getOrders,
  putOrderStatus,
  getOrderDetailByRz,
} from 'services';

import {
  addOrderSuccess,
  addOrderError,
  fetchOrderDetailSuccess,
  fetchOrderDetailError,
  fetchOrderDetailByRzSuccess,
  fetchOrderDetailByRzError,
  fetchOrdersSuccess,
  fetchOrdersError,
  updateOrderStatusSuccess,
  updateOrderStatusError,
  fetchCartCount,
} from 'store/actions';

function* addOrderItem({ payload }) {
  try {
    const response = yield call(postOrder, payload);
    if (!response.message) {
      yield put(addOrderSuccess(response.data));
      yield put(fetchCartCount());
    } else {
      yield put(addOrderError(response.message));
    }
  } catch (error) {
    yield put(addOrderError(error));
  }
}

export function* watchAddOrder() {
  yield takeLatest(ADD_ORDER, addOrderItem);
}

function* fetchOrderItemDetail({ payload }) {
  try {
    const response = yield call(getOrderDetail, payload);
    if (!response.message) {
      yield put(fetchOrderDetailSuccess(response.data));
    } else {
      yield put(fetchOrderDetailError(response.message));
    }
  } catch (error) {
    yield put(fetchOrderDetailError(error));
  }
}

export function* watchFetchOrderDetail() {
  yield takeLatest(FETCH_ORDER_DETAIL, fetchOrderItemDetail);
}

function* fetchOrderItemDetailRz({ payload }) {
  try {
    const response = yield call(getOrderDetailByRz, payload);
    if (!response.message) {
      yield put(fetchOrderDetailByRzSuccess(response.data));
    } else {
      yield put(fetchOrderDetailByRzError(response.message));
    }
  } catch (error) {
    yield put(fetchOrderDetailByRzError(error));
  }
}

export function* watchFetchOrderDetailByRz() {
  yield takeLatest(FETCH_ORDER_DETAIL_RZ, fetchOrderItemDetailRz);
}

function* fetchOrderItems({ payload }) {
  try {
    const response = yield call(getOrders, payload);
    if (!response.message) {
      yield put(
        fetchOrdersSuccess(response.data, {
          ...payload,
          total: response.totalCount,
        })
      );
    } else {
      yield put(fetchOrdersError(response.message));
    }
  } catch (error) {
    yield put(fetchOrdersError(error));
  }
}

export function* watchFetchOrders() {
  yield takeLatest(FETCH_ORDERS, fetchOrderItems);
}

function* updateOrderItemStatus({ payload }) {
  try {
    const response = yield call(putOrderStatus, payload);
    if (!response.error) {
      yield put(updateOrderStatusSuccess({ ...response.data }));
    } else {
      yield put(updateOrderStatusError(response.message));
    }
  } catch (error) {
    yield put(updateOrderStatusError(error));
  }
}

export function* watchUpdateOrderStatus() {
  yield takeLatest(UPDATE_ORDER_STATUS, updateOrderItemStatus);
}

export default function* rootSaga() {
  yield all([
    fork(watchAddOrder),
    fork(watchFetchOrderDetail),
    fork(watchFetchOrderDetailByRz),
    fork(watchFetchOrders),
    fork(watchUpdateOrderStatus),
  ]);
}
